export default function IconRuler({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_83_375)">
                <path
                    d="M29 10H3C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H29C29.2652 22 29.5196 21.8946 29.7071 21.7071C29.8946 21.5196 30 21.2652 30 21V11C30 10.7348 29.8946 10.4804 29.7071 10.2929C29.5196 10.1054 29.2652 10 29 10ZM28 20H4V12H8V16H10V12H15V16H17V12H22V16H24V12H28V20Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_83_375">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
